/**
 * @enum
 */
export const spacing = {
    none: '0',
    tiny: '8px',
    small: '16px',
    medium: '24px',
    large: '36px',
    huge: '48px',
    giant: '64px',
} as const;

export const icons = {
    tiny: '10px',
    small: '16px',
    medium: '24px',
    large: '36px',
    huge: '48px',
} as const;

export const font = {
    small: '14px',
    medium: '16px',
    large: '24px',
    huge: '32px',
} as const;
